// utils/viewSelection.ts
// The customer/date-range the user is currently looking at.
//
// This lives in sessionStorage, NOT localStorage, and that is deliberate: the
// chameleon/demo identity (`chameleon_session`) is per-tab, so the selection made
// under that identity must be per-tab too. When the two scopes disagreed, a demo
// tab and a normal tab shared one selection through localStorage's cross-tab
// `storage` event and stomped each other — each adopting the other's customer id,
// then firing requests for it under its own identity, and getting a 403 back.
// Keep both scopes per-tab and the two tabs simply ignore each other.

export const CUSTOMER_ID_KEY = 'selectedCustomerId';
export const DATE_RANGE_KEY = 'selectedDateRange';

export const readSelectedCustomerId = (): number | null => Number(sessionStorage.getItem(CUSTOMER_ID_KEY)) || null;

export const writeSelectedCustomerId = (id: number | null): void => {
    try {
        sessionStorage.setItem(CUSTOMER_ID_KEY, id?.toString() || '');
    } catch (e) {
        console.warn('Unable to write selectedCustomerId', e);
    }
};

export const readSelectedDateRange = (): string | null => sessionStorage.getItem(DATE_RANGE_KEY);

export const writeSelectedDateRange = (value: string): void => {
    try {
        sessionStorage.setItem(DATE_RANGE_KEY, value);
    } catch (e) {
        console.warn('Unable to write selectedDateRange', e);
    }
};

export const clearSelectedDateRange = (): void => {
    sessionStorage.removeItem(DATE_RANGE_KEY);
    localStorage.removeItem(DATE_RANGE_KEY); // sweep the pre-migration copy
};

/** Drop the whole selection — on logout, and on entering or leaving a chameleon. */
export const clearViewSelection = (): void => {
    sessionStorage.removeItem(CUSTOMER_ID_KEY);
    sessionStorage.removeItem(DATE_RANGE_KEY);
    // Sweep the pre-migration localStorage copies so they don't linger as cruft.
    localStorage.removeItem(CUSTOMER_ID_KEY);
    localStorage.removeItem(DATE_RANGE_KEY);
};
